import axios from 'axios'

import { uuid, localStorage } from '../utils/basicUtil'

/**
 *
 * @param file upload file
 * @param functionPoint upload function
 * @param extraParams upload extra params
 * @return Promise<any>
 */
export function UploadService (file, blob = false) {
  const fileName = uuid()
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await axios.post(`/api/v2/base/oss/get-signature`, { fileName, functionPoint: 'mobilecompany' }, { headers: { 'X-Access-Token': localStorage.get('X-Access-Token') } })
      if (data.code !== '200') {
        reject(new Error('上传服务出错'))
      } else {
        if (data.data) {
          let formData = new FormData()
          let fileDirectory = data.data.fileDirectory
          let fileType = ''
          if (!blob) {
            fileType = file.name.substr(file.name.lastIndexOf('.'))
          } else {
            fileType = file.type.substr(file.type.lastIndexOf('/'))
          }

          data.data.key = `${fileDirectory}${fileName}${fileType}`
          data.data.Filename = `${fileDirectory}${fileName}${fileType}`
          data.data.OSSAccessKeyId = data.data.accessId

          for (let key in data.data) {
            formData.append(key, data.data[key])
          }

          formData.append('success_action_status', '200')
          formData.append('file', file)
          const ossData = await axios.post(data.data.host, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          if (ossData.status === 200) {
            resolve({ success: true, url: `${data.data.host}/${data.data.Filename}` })
          } else {
            reject(new Error('上传服务出错'))
          }
        } else {
          reject(new Error('上传服务出错'))
        }
      }
    } catch (e) {
      reject(e)
    }
  })
}

export default UploadService
